import { DownloadProgressModal } from "./DownloadProgressModal";

// The chunked-download progress dialog wired to a useDuckActions() instance.
export const DuckDownloadModal = ({ actions }) => {
  const { downloadState: dl } = actions;
  return <DownloadProgressModal {...dl.downloadState} onCancel={dl.cancelDownload} onRepaint={dl.repaintAndDownload} onDownloadAnyway={dl.downloadAnyway} />;
};
